import { AvField, AvForm } from "availity-reactstrap-validation"
import CardComponent from "components/Card"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Modal, ModalFooter } from "reactstrap"
import { newPasswordSetFlag, userNewPassword } from "../../store/actions"

const ResetPasswordModal = ({ modal, toggle }) => {
  const dispatch = useDispatch()
  const { setFlag } = useSelector(state => state.NewPassword)
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false)
  const [isPasswordShow, setIsPasswordShow] = useState(false)
  const [isOldPasswordShow, setIsOldPasswordShow] = useState(false)

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    // props.registerUser(values)
    const user = JSON.parse(localStorage.getItem("authUser"))
    const data = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      email: user.email,
    }
    dispatch(userNewPassword(data))
  }

  useEffect(() => {
    if (setFlag) {
      toggle()
      dispatch(newPasswordSetFlag(false))
    }
  }, [setFlag])

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <CardComponent
          subtitle="Reset Password"
          closeButton={modal}
          toggleCloseButton={toggle}
        >
          <AvForm
            className="form-horizontal mt-4 mx-3"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3 row text-start">
              <label
                for="example-text-input"
                className="col-md-3 col-form-label"
              >
                Old Password
              </label>
              <div className="col-md-9">
                <AvField
                  d="oldPassword"
                  name="oldPassword"
                  className="form-control"
                  placeholder="Enter Old Password"
                  type={isOldPasswordShow ? "text" : "password"}
                  required
                />
                <i
                  className={`mdi ${
                    isOldPasswordShow ? "mdi-eye" : "mdi-eye-off"
                  } fs-3 position-absolute`}
                  style={{
                    top: "0px",
                    right: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsOldPasswordShow(!isOldPasswordShow)}
                ></i>
              </div>
            </div>
            <div className="mb-3 row text-start">
              <label
                for="example-text-input"
                className="col-md-3 col-form-label"
              >
                New Password
              </label>
              <div className="col-md-9">
                <AvField
                  d="newPassword"
                  name="newPassword"
                  className="form-control"
                  placeholder="Enter New Password"
                  type={isPasswordShow ? "text" : "password"}
                  required
                />
                <i
                  className={`mdi ${
                    isPasswordShow ? "mdi-eye" : "mdi-eye-off"
                  } fs-3 position-absolute`}
                  style={{
                    top: "0px",
                    right: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsPasswordShow(!isPasswordShow)}
                ></i>
              </div>
            </div>
            <div className="mb-3 row text-start">
              <label
                for="example-text-input"
                className="col-md-3 col-form-label"
              >
                Confirm Password
              </label>
              <div className="col-md-9">
                <AvField
                  d="newPassword"
                  name="confirmPassword"
                  className="form-control"
                  placeholder="Enter New Password"
                  type={isConfirmPasswordShow ? "text" : "password"}
                  required
                />
                <i
                  className={`mdi ${
                    isConfirmPasswordShow ? "mdi-eye" : "mdi-eye-off"
                  } fs-3 position-absolute`}
                  style={{
                    top: "0px",
                    right: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setIsConfirmPasswordShow(!isConfirmPasswordShow)
                  }
                ></i>
              </div>
            </div>
            <ModalFooter>
              <Button color="primary" type="submit">
                RESET PASSWORD
              </Button>
              <Button color="secondary" onClick={toggle}>
                CANCEL
              </Button>
            </ModalFooter>
          </AvForm>
        </CardComponent>
      </Modal>
    </>
  )
}

export default ResetPasswordModal
